const Loading = () => {
  return (
    <div className="text-center animate-pulse text-4xl font-bold align-middle text-gray-700">
      Loading...
    </div>
  );
};

export default Loading;
